export enum SALUTATION {
    MRS = '1',
    MR = '2',
    NO_INDICATION = '3',
}
